import useTriggerAnalyticsEvent from './use-trigger-analytics-event';
const useTriggerPromosAnalytics = (shouldTrigger, chartData) => {
    const getCurrentEvent = () => {
        const promoExpiresEvent = 'promoCenterDetails.promoExpires';
        if (!chartData) {
            return promoExpiresEvent;
        }
        const { promoHasBeenPaid, isPromotionPastPeriod } = chartData;
        if (isPromotionPastPeriod) {
            return 'promoCenterDetails.deferredInterestPastDue';
        }
        if (promoHasBeenPaid) {
            return 'promoCenterDetails.deferredInterestSuccess';
        }
        return promoExpiresEvent;
    };
    useTriggerAnalyticsEvent(getCurrentEvent(), undefined, shouldTrigger);
};
export default useTriggerPromosAnalytics;
//# sourceMappingURL=use-trigger-promos-analytics.js.map